import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from '../../components/layout/AppHeader.jsx';

const NAV = [
  { to: '/planning/models',    label: 'Plan Models',        testid: 'planning-nav-models'    },
  { to: '/planning/grid',      label: 'Planning Grid',      testid: 'planning-nav-grid'      },
  { to: '/planning/scenarios', label: 'Scenario Compare',   testid: 'planning-nav-scenarios' },
  { to: '/planning/forecast',  label: 'Forecast',           testid: 'planning-nav-forecast'  },
  { to: '/planning/workforce', label: 'Workforce Planning', testid: 'planning-nav-workforce' },
  { to: '/planning/variance',  label: 'Variance Report',    testid: 'planning-nav-variance'  },
];

export default function PlanningShell() {
  return (
    <div className="hr-shell" data-testid="planning-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Planning / FP&amp;A</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} data-testid={n.testid} className={({ isActive }) => (isActive ? 'active' : '')}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
